// extracted by mini-css-extract-plugin
export default {"filterTabs":"FilterTabs_filterTabs__X7AMU","navItem":"FilterTabs_navItem__vNIoV","navLink":"FilterTabs_navLink__Oel0j","activeTab":"FilterTabs_activeTab__svKGB"};